import { render } from "./App.vue?vue&type=template&id=7aec938d"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7aec938d&lang=scss"

import exportComponent from "/home/marvin/go/src/github.com/emvi/lernapp-prototype/app/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__